import { apiClient } from './client';
import { unwrapAndTransform } from '../utils/api-response';
// ---------------------------------------------------------------------------
// All unwrapping now handled by unwrapAndTransform
// Eliminates: manual response.data.data unwrapping patterns (4 occurrences)
// ---------------------------------------------------------------------------
export const rebaselineApi = {
    getRebaselineStatus: async () => {
        const response = await apiClient.get('/v1/admin/rebaseline/status');
        const result = unwrapAndTransform(response);
        return result.traits;
    },
    triggerRebaseline: async (traitId, traitType) => {
        const body = traitId && traitType ? { traitId, traitType } : {};
        const response = await apiClient.post('/v1/admin/rebaseline/trigger', body);
        return unwrapAndTransform(response);
    },
    getRebaselineSchedule: async () => {
        const response = await apiClient.get('/v1/admin/rebaseline/schedule');
        return unwrapAndTransform(response);
    },
    updateRebaselineSchedule: async (intervalOverrideDays) => {
        const response = await apiClient.put('/v1/admin/rebaseline/schedule', {
            intervalOverrideDays,
        });
        return unwrapAndTransform(response);
    },
};
